import { ROUTE_CONNECT } from 'new/constants/pathnames';
import { assignFlowToProject, clearSelectedFlow } from 'js/actions';
import { clearCurrentProjectId } from 'js/actions/currentProject';

export const assignFlowToProjectIfPresent = async ({
  dispatch,
  flowNodeId,
  currentProjectId,
}: {
  dispatch: any;
  flowNodeId?: number | string | null;
  search?: string;
  getState?: () => any;
  currentProjectId?: number | null;
}): Promise<number | undefined> => {
  // Try to get project ID from Redux state first
  let projectId: number | undefined;

  if (currentProjectId) {
    projectId = currentProjectId;
  }

  if (!projectId || !flowNodeId) {
    return undefined;
  }

  try {
    await dispatch(assignFlowToProject({ id: Number(flowNodeId), projectId }));
    // Clear currentProjectId after successful assignment to prevent
    // unintended assignment to project in future flow creations
    dispatch(clearCurrentProjectId());
    return projectId;
  } catch (error) {
    console.error('❌ Failed to assign flow to project:', error);
    throw error;
  }
};

export const redirectToProjectIfNeeded = (
  history: any,
  projectId?: number,
  dispatch?: any,
): void => {
  if (projectId) {
    // Clear any selected flow state before redirecting
    if (dispatch) {
      dispatch(clearSelectedFlow());
    }

    const redirectPath = `${ROUTE_CONNECT}/projects/${projectId}`;

    history.replace(redirectPath);

    // Clear the project ID from Redux after redirecting
    // This ensures subsequent flows won't be automatically assigned to this project
    if (dispatch) {
      dispatch(clearCurrentProjectId() as any);
    }
  }
};
